<div class="flex-grow-1 bg-image">
  @if (!loadingData) {
    <nz-page-header [title]="pageTitle"/>
    <section class="container-lg my-5">
      <div class="row justify-content-center">
        <div class="col-12 col-md-9">
          <nz-stepper
            [steps]="formSteps"
            [selectedStep]="selectedFormStep"
            (onSelectStep)="onSelectFormStep($event)"/>
        </div>
      </div>
      <ng-container *ngTemplateOutlet="errorMessages"></ng-container>
    </section>
    <section class="container-lg my-5">
      <div [class.d-none]="selectedFormStep !== 1">
        <nz-ad-form-step-01
          [form]="getForStep01()"
          (previewImagesChange)="onPreviewImagesChange($event)"
          (changeAdSpecifications)="onChangeAdSpecifications($event)"/>
        <ng-container *ngTemplateOutlet="errorMessages"></ng-container>
        <div class="row justify-content-end my-5">
          <div class="col-6 col-sm-4 col-md-2">
            <button
              (click)="onSelectFormStep(2)"
              class="w-100 btn btn-nz-primary">
              Напред
            </button>
          </div>
        </div>
      </div>
      <div [class.d-none]="selectedFormStep !== 2">
        <nz-ad-form-step-02 [form]="getForStep02()"/>
        <ng-container *ngTemplateOutlet="errorMessages"></ng-container>
        <div class="row justify-content-end my-5">
          <div class="col-6 col-sm-4 col-md-2">
            <button
              (click)="onSelectFormStep(1)"
              class="w-100 btn btn-nz-outline-primary-light">
              Назад
            </button>
          </div>
          <div class="col-6 col-sm-4 col-md-2">
            <button
              (click)="onSelectFormStep(3)"
              class="w-100 btn btn-nz-primary">
              Напред
            </button>
          </div>
        </div>
      </div>
      <div [class.d-none]="selectedFormStep !== 3">
        <nz-ad-form-step-03
          [form]="getForStep03()"
          (adSelectedPaymentOptionIdsChange)="onAdSelectedPaymentOptionIdsChange($event)"
          (adSelectedDeliveryOptionIdsChange)="onAdSelectedDeliveryOptionIdsChange($event)"/>
        <ng-container *ngTemplateOutlet="errorMessages"></ng-container>
        <div class="row justify-content-end my-5">
          <div class="col-6 col-sm-4 col-md-2">
            <button
              (click)="onSelectFormStep(2)"
              class="w-100 btn btn-nz-outline-primary-light">
              Назад
            </button>
          </div>
          <div class="col-6 col-sm-4 col-md-2">
            <button
              (click)="onSelectFormStep(4)"
              class="w-100 btn btn-nz-primary">
              Напред
            </button>
          </div>
        </div>
      </div>
      <div [class.d-none]="selectedFormStep !== 4 || !isFormStep01Valid || !isFormStep02Valid || !isFormStep03Valid">
        <nz-ad-form-step-04 [adCardData]="adCardData"/>
        @if (!!responseErrorMessage) {
          <div class="text-danger text-center">
            {{ responseErrorMessage }}
          </div>
        }
        <div class="row justify-content-end my-5">
          <div class="col-6 col-sm-4 col-md-2">
            <button
              type="button"
              (click)="onSubmit()"
              [disabled]="loadingSubmit"
              class="w-100 btn btn-nz-primary">
              @if (loadingSubmit) {
                <span class="me-2 spinner-border spinner-border-sm"></span>
              }
              <span>Запази</span>
            </button>
          </div>
        </div>
      </div>
    </section>
    <ng-template #errorMessages>
      @if (!isFormStep01Valid || !isFormStep02Valid || !isFormStep03Valid) {
        <div class="my-5 alert alert-danger rounded-3">
          <h5 class="m-0 pb-3 d-flex flex-wrap justify-content-center gap-3">
            @if (!isFormStep01Valid) {
              <div class="badge bg-danger rounded-1">Стъпка 1</div>
            }
            @if (!isFormStep02Valid) {
              <div class="badge bg-danger rounded-1">Стъпка 2</div>
            }
            @if (!isFormStep03Valid) {
              <div class="badge bg-danger rounded-1">Стъпка 3</div>
            }
          </h5>
          <div class="text-center">
            {{ errorMessage }}
          </div>
        </div>
      }
    </ng-template>
  } @else {
    <nz-loader/>
  }
</div>
